import { Link } from "react-router-dom";
import { MapPin, Building2 } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { VerifiedBadge, getTier } from "@/components/VerifiedBadge";

const FALLBACK = "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGZhY2FkZXxlbnwwfHx8fDE3ODgwOTU3MDJ8MA&ixlib=rb-4.1.0&q=85";

export const BusinessCard = ({ business }) => {
  const img = mediaUrl(business.logo_url) || FALLBACK;
  const tier = getTier(business);
  return (
    <Link
      to={`/business/${business.slug || business.id}`}
      data-testid={`business-card-${business.id}`}
      className="group flex flex-col bg-white border border-slate-200 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-slate-300"
    >
      <div className="h-32 w-full overflow-hidden bg-slate-100 relative">
        <img src={img} alt={business.business_name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {tier !== "basic" && (
          <span className="absolute top-3 right-3">
            <VerifiedBadge tier={tier} size="sm" />
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col gap-2 flex-1">
        <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-brand">{business.category}</span>
        <h3 className="font-display font-bold text-lg text-slate-900 leading-tight line-clamp-2">{business.business_name}</h3>
        {(business.city || business.state) && (
          <p className="flex items-center gap-1.5 text-sm text-slate-500 mt-auto pt-1">
            <MapPin size={14} /> {[business.city, business.state].filter(Boolean).join(", ")}
          </p>
        )}
        {business.gst_number && (
          <div className="flex items-center gap-1.5 text-xs text-slate-400 font-medium">
            <Building2 size={13} /> {business.gst_number}
          </div>
        )}
      </div>
    </Link>
  );
};
